import { createContext } from "react";
import { IWithChildren } from "../../Interfaces/IWithChildren";
import { SrvConnector } from "../../Services/SrvConnector";
import { IServiceContextHandlers } from "./IServiceContextHandlers";




export const ServiceContext = createContext<IServiceContextHandlers>({} as IServiceContextHandlers);

export const ServiceContextProvider = ({ children }: IWithChildren) => {

    const srvConnector = new SrvConnector();

    return (
        <ServiceContext.Provider value={{ SrvContext: srvConnector }}>
            {children}
        </ServiceContext.Provider>
    );


};